import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface NetworkConfigReq {
  /** 设备id */
  device_id: string
}

export interface Config {
  /** true:自动获取IP地址 false：手动设置ip地址 */
  is_auto_ip: boolean
  /** 当前IP地址 */
  current_ip: string
  /** true:自动获取DNS地址 false：手动设置DNS地址 */
  is_auto_dns: boolean
  /** 当前子网网关 */
  current_subnet_mask?: string
  /** 当前默认网关 */
  default_gateway?: string
  /** DNS服务器 */
  dns?: string
  /** 网卡mac */
  mac?: string
  /** 网卡名 */
  name?: string
}

export interface NetworkConfigRes {
  /** 网络配置列表 */
  configs?: Config[]
}

@Injectable()
export class NetworkConfigService {
  constructor (private http: Http) {
  }

  getNetworkConfig (data: NetworkConfigReq) {
    return this.http.post<NetworkConfigRes>('/terminal/hardware/network_config', data)
  }
}
